module.exports = __webpack_public_path__ + "media/kommissar_1.1a_1.257e2ed9.mp3";